import { bl_catalog_login_subject_link_import_file_helper_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';


export class CatalogLoginSubjectLinkFileHelperContainerModel extends BaseContainerModel {
  bl_catalog_login_subject_link_import_file_helper: bl_catalog_login_subject_link_import_file_helper_RowClass = new bl_catalog_login_subject_link_import_file_helper_RowClass();
}
